// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-4f09880c] .el-table__cell:first-child .cell,[data-v-4f09880c] .el-table__cell:last-child .cell {\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n}\n[data-v-4f09880c] .tabNumWidth .el-form-item {\n  margin-bottom: 0 !important;\n}\n[data-v-4f09880c] .el-table__cell {\n  padding: 0 !important;\n}\n.pictrue[data-v-4f09880c] {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
